module.exports = __webpack_public_path__ + "static/media/kw.8758e4ab.svg";